module.exports = __webpack_public_path__ + "img/LLJF.3f85dca6.png";